import { NestedColumnType } from '@/apis/types'

export const SATPEN_TABLE_COLUMN: NestedColumnType[] = [
  {
    id: 'no',
    displayName: 'No',
    childColumns: [],
  },
  {
    id: 'npsn',
    displayName: 'NPSN',
    childColumns: [],
  },
  {
    id: 'nama',
    displayName: 'Nama Satuan Pendidikan',
    childColumns: [],
  },
  {
    id: 'bentukPendidikanGroup',
    displayName: 'Bentuk',
    childColumns: [],
  },
  {
    id: 'jenisPendidikan',
    displayName: 'Jenis',
    childColumns: [],
  },
  {
    id: 'alamatJalan',
    displayName: 'Alamat',
    childColumns: [],
  },
  {
    id: 'namaDesa',
    displayName: 'Kelurahan',
    childColumns: [],
  },
  {
    id: 'statusSatuanPendidikan',
    displayName: 'Status',
    childColumns: [],
  },
]

export const SATPEN_TABLE__EXCLUDE_ALAMAT_COLUMN: NestedColumnType[] = [
  {
    id: 'no',
    displayName: 'No',
    childColumns: [],
  },
  {
    id: 'npsn',
    displayName: 'NPSN',
    childColumns: [],
  },
  {
    id: 'nama',
    displayName: 'Nama Satuan Pendidikan',
    childColumns: [],
  },
  {
    id: 'bentukPendidikanGroup',
    displayName: 'Jenjang',
    childColumns: [],
  },
  {
    id: 'jenisPendidikan',
    displayName: 'Jenis',
    childColumns: [],
  },
  {
    id: 'namaDesa',
    displayName: 'Kelurahan',
    childColumns: [],
  },
  {
    id: 'statusSatuanPendidikan',
    displayName: 'Status',
    childColumns: [],
  },
]

export const SATPEN_MAP_COLUMN_TO_SORT_PARAM = {
  namaDesa: 'nama_desa_dagri',
  bentukPendidikanGroup: 'bentuk_pendidikan',
}

export const SATPEN_MAP_SORT_PARAM_TO_COLUMN = {
  nama_desa_dagri: 'namaDesa',
  bentuk_pendidikan: 'bentukPendidikanGroup',
}
